import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

const LanguageSwitcher = ({ menuZ = 1200 }) => {
  const { i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setMenuOpen(false);
  };

  return (
    <div ref={dropdownRef} style={{ position: "relative" }}>
      <button
        onClick={() => setMenuOpen((o) => !o)}
        aria-label="Cambiar idioma"
        style={{
          background: "none",
          border: "none",
          cursor: "pointer",
          padding: 0,
          lineHeight: 1,
        }}
      >
        <img
          src="/img/tierra.png"
          alt="Idioma"
          style={{ width: 24, height: 24 }}
        />
      </button>

      {menuOpen && (
        <ul
          style={{
            position: "absolute",
            top: "100%",
            right: 0,
            marginTop: 8,
            padding: 0,
            listStyle: "none",
            backgroundColor: "#fff",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            borderRadius: 4,
            minWidth: 120,
            zIndex: menuZ,
          }}
        >
          <li>
            <button
              onClick={() => changeLanguage("es")}
              style={{
                width: "100%",
                padding: "0.5rem 1rem",
                background: "none",
                border: "none",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              Español
            </button>
          </li>
          <li>
            <button
              onClick={() => changeLanguage("en")}
              style={{
                width: "100%",
                padding: "0.5rem 1rem",
                background: "none",
                border: "none",
                textAlign: "left",
                cursor: "pointer",
              }}
            >
              English
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
